export default __webpack_public_path__ + "media/images/icons/monitoring-outline-b7caaf84dabadc39ce841c70dc168e90.svg";